<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />

      <p>
        {{ $t('maintenance.reminderSender.desc') }}
      </p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end d-flex flex-row">
          <McButton
            variant="secondary"
            @click="$router.push({ name: 'Email Service Alert' })"
            icon="icon-outline_arrow-left"
            :text="$t('global.back')"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <!-- Table -->
        <div class="table-responsive my-3">
          <McGrapqlTable
            :apiClient="query"
            :fields="fields"
            :hasCheckbox="false"
            :searchable="true"
            :withCard="true"
          >
            <!-- dikomen untuk enhancement kedepan -->
            <!-- <template #thead-top>
              <b-tr>
                <b-th rowspan="2">
                  <div class="d-flex align-items-center">
                    {{ $t('maintenance.field.deliveryDate') }}
                  </div>
                </b-th>
                <b-th rowspan="2">
                  <div class="d-flex align-items-center">
                    {{ $t('maintenance.field.scheduleName') }}
                  </div>
                </b-th>
                <b-th colspan="2" class="text-center">
                  {{ $t('maintenance.field.reminderRecipients') }}
                </b-th>
                <b-th rowspan="2">
                  <div class="d-flex align-items-center">
                    {{ $t('master.list.driver.status') }}
                  </div>
                </b-th>
              </b-tr>
            </template> -->
            <template #cell(sentOn)="data">
              {{ data.value ? momentDMY_HI(data.value) + ' WIB' : '' }}
            </template>
            <template #cell(recipients)="data">
              {{ data.value ? data.value : '' }}
            </template>
            <template #cell(status)="data">
              <span :class="`mc-status mc-status--${data.value.color}`">
                {{ data.value.label }}
              </span>
            </template>
          </McGrapqlTable>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import McGrapqlTable from '@/components/McGrapqlTable'
import McButton from '@/components/McButton'
import { GET_REPORT_SCHEDULER_HISTORY } from '@/services/api/report/report'
import { Helper } from '@/mixin/helper'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Servis',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McGrapqlTable,
    McButton,
  },

  mixins: [Helper],

  data() {
    return {
      show_model: [],
      data: [],
    }
  },

  computed: {
    title() {
      return `${this.$t('global.reminderDelivery')}`
    },

    items() {
      return [
        {
          text: this.$t('maintenance.title'),
          to: { name: 'Service' },
        },
        {
          text: this.$t('maintenance.frontPage.title.serviceAlert'),
          to: { name: 'List Service Alert' },
        },
        {
          text: this.$t('global.reminderDelivery'),
        },
      ]
    },

    fields() {
      // dikomen untuk enhancement kedepan with colspan and rowspan
      return [
        {
          key: 'sentOn',
          label: this.$t('maintenance.field.deliveryDate'),
          sortable: true,
          thClass: 'mc-table--250',
          // thClass: 'mc-table--250 d-none',
          isRedirectable: false,
        },
        {
          key: 'scheduleName',
          label: this.$t('maintenance.field.scheduleName'),
          sortable: true,
          // thClass: 'd-none',
        },
        {
          key: 'recipients',
          label: this.$t('maintenance.field.reminderRecipients'),
          isSortable: true,
        },
        // {
        //   key: 'whatsapp',
        //   label: 'WhatsApp',
        // },
        // {
        //   key: 'email',
        //   label: this.$t('notification.setting.emailNotification.email'),
        // },
        {
          key: 'status',
          label: this.$t('master.list.driver.status'),
          sortable: true,
          // thClass: 'd-none',
        },
      ]
    },

    query() {
      return {
        get: async (filter) => {
          return this.get(filter)
        },
      }
    },
  },

  methods: {
    async get(filter) {
      const res = await this.$apollo.query({
        query: GET_REPORT_SCHEDULER_HISTORY,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...filter,
            reportName: 'Pengingat Servis',
          },
        },
      })

      res.data.reportSchedulerHistory.reportSchedulerHistory.data.forEach((row) => {
        let format = {}
        if (row.status.includes('S')) {
          format = { color: 'green', label: this.$t('global.object.sent') }
        } else {
          format = { color: 'red', label: this.$t('global.failed') }
        }

        row.status = format
      })

      const result = {
        data: res.data.reportSchedulerHistory.reportSchedulerHistory.data,
        pagination: res.data.reportSchedulerHistory.reportSchedulerHistory.pagination,
      }

      this.data = res.data.reportSchedulerHistory.reportSchedulerHistory.data

      return result
    },
  },
}
</script>
